import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.END_PACKING_BAG.REQUEST, saga.completePackingBag);
    yield takeLatest(ACTION.END_PACKING_BAG.FAILED, saga.completePackingBagFailed);
    yield takeLatest(ACTION.END_PACKING_BAG.SUCCESS, saga.completePackingBagSuccess);
}
